import { protectedRoute } from '@/modules/core/root/protected/route';
import { RouteErrorHandler } from '@/shared/components/route-error-handler';
import { createRoute, Outlet } from '@tanstack/react-router';

export const chargeCenterRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'charge-center',
  component: Outlet,
  errorComponent: ({ error, reset }) => {
    return <RouteErrorHandler error={error} reset={reset} routeName="charge-center" />;
  },
});
